import React from "react";
import {useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { PageSettings } from "./../config/page-settings.js";
import { Api } from "./../app-controller.js"; //esta es la libreria donde se llama el api.fetch para la llamadas API.REST
import { useAuth } from "../components/content/auth.jsx";

class Profile extends React.Component {
  static contextType = PageSettings;

  initialState = {
    dataProfile: { },
  };
  state = this.initialState;

  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

	this.handleEdit = this.handleEdit.bind(this);
  }

  componentDidMount() {
    Api.loading(true);
    Api.fetch("app/getDataProfile").then((data) => {
      if (data) {
        this.setState({ dataProfile: data });
        Api.loading(false);
      }
    });

    this.context.handleSetPageSidebar(true); //para cargar el sidebar en la vista
    this.context.handleSetPageHeader(true); //para cargar el header en la vista
  }

  handleEdit(e){
	window.location = "/perfil-editar";
  }

  render() {
    return (
      <div>
        {/* <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Perfil</li>
        </ol> */}
 
        {
          <Panel>
            <div className="row">
              <div className="col-md-9" style={{ left: "10%" }}>
                <Panel>
                  <PanelBody>
                    <form style={{ margin: "2%" }}>
                    <h1 className="page-header">
                      PERFIL<small></small>
                    </h1>
                      {/*Nombre completo *******************************************/}
                      <div className="form-group row col-md-9">
                        <label className="col-form-label col-md-3">
                          {" "}
                          Nombre:{" "}
                        </label>
                        <label className="col-form-label col-md-9">
                          {this.state.dataProfile.nombre_completo}
                        </label>
                      </div>
                      {/*Departamento **********************************************/}
                      <div className="form-group row col-md-9">
                        <label className="col-form-label col-md-3">
                          {" "}
                          Departamento:{" "}
                        </label>
                        <label className="col-form-label col-md-9">
                          {this.state.dataProfile.nombre_departamento}
                        </label>
                      </div>
                      {/*Municipio **************************************************/}
                      <div className="form-group row col-md-9">
                        <label className="col-form-label col-md-3">
                          {" "}
                          Municipio:{" "}
                        </label>
                        <label className="col-form-label col-md-9">
                          {this.state.dataProfile.nombre_municipio}
                        </label>
                      </div>
                      {/*Teléfono ***************************************************/}
                      <div className="form-group row col-md-9">
                        <label className="col-form-label col-md-3">
                          {" "}
                          Teléfono:{" "}
                        </label>
                        <label className="col-form-label col-md-9">
                          {this.state.dataProfile.telefono}
                        </label>
                      </div>
                      {/*Correo *****************************************************/}
                      <div className="form-group row col-md-9">
                        <label className="col-form-label col-md-3">
                          {" "}
                          Correo:{" "}
                        </label>
                        <label className="col-form-label col-md-9">
                          {this.state.dataProfile.correo}
                        </label>
                      </div>

                      <div style={{ marginBottom: "10%" }}>
                        <button 
							className="btn btn-primary m-r-5"
							type="button"
							onClick={this.handleEdit}
							>
                          	Editar perfil
                        </button>
                      </div>
                    </form>
                  </PanelBody>
                </Panel>
              </div>
            </div>
          </Panel>
        }
      </div>
    );
  }
}
//aqui se anaden las propiedades de autenticacion y el this.props.history de libreria useHistory
export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <Profile auth={auth} history={history} {...props} />;
};
